export default {"src":"/_next/static/media/naos_black.10fd43a2.svg","height":45,"width":226,"blurWidth":0,"blurHeight":0};